import type { DeliveryGroup } from '@/modules/shippingMethod/domain/ShippingMethod';

export enum CardDeliveryInfoVariants {
  SAME_DAY = 'same-day',
  NEXT_DAY = 'next-day',
  SCHEDULED = 'scheduled',
  SCHEDULED_DEFERRED = 'scheduled-deferred',
  DATE_RANGE = 'date-range'
}

export enum TimeSlotNames {
  AM1 = 'AM1',
  TH = 'TH',
  PM1 = 'PM1',
  PM2 = 'PM2'
}

export enum CardType {
  CENCOSUD = 'cencosud',
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  GENERIC = 'generic'
}

export type TabActive = 'despacho' | 'retiro';

export interface ShippingTabNavigationProps {
  group: DeliveryGroup;
  setTabActive: (tab: TabActive) => void;
  tabActive: string;
}
